import LineChart from '@/components/LineChart';

// 示例数据
const data = [
  { date: '2024-01', value: 100, category: 'AI' },
  { date: '2024-02', value: 150, category: 'AI' },
  { date: '2024-03', value: 200, category: 'AI' },
  { date: '2024-01', value: 80, category: 'Space' },
  { date: '2024-02', value: 120, category: 'Space' },
  { date: '2024-03', value: 180, category: 'Space' },
  { date: '2024-01', value: 60, category: 'Bio' },
  { date: '2024-02', value: 90, category: 'Bio' },
  { date: '2024-03', value: 140, category: 'Bio' },
];

export default function ChartDemo() {
  return (
    <div className="py-16">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold mb-8">投资趋势分析</h2>
        <div className="bg-gray-900 rounded-xl p-6">
          <LineChart
            data={data}
            width={800}
            height={450}
          />
        </div>
      </div>
    </div>
  );
}
